
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { fileUploadFinish } from '../../actions/appealActions'
import { CardBody, Card, CardTitle, Button, FormGroup, CardFooter, Progress } from 'reactstrap'
import { withRouter } from 'react-router'
import { FaFile, FaUpload } from 'react-icons/fa'
import { API_URL } from '../../settings'

import PropTypes from 'prop-types'
var ReactS3Uploader = require('react-s3-uploader')

class FileUpload extends Component {
  constructor (props) {
    super(props)
    this.uploader = null
    this.handleUpload = this.handleUpload.bind(this)
    this.onFinish = this.onFinish.bind(this)
    this.onProgress = this.onProgress.bind(this)
    this.onUploadStart = this.onUploadStart.bind(this)
    this.onError = this.onError.bind(this)
    this.state = {
      fileProgress: 0,
      file: null,
      displayBar: false
    }
  }

  handleUpload () {
    this.uploader.uploadFile()
    this.setState({ fileProgress: 0, displayBar: true })
  }

  onFinish (e) {
    this.uploader.clear()
    this.setState({ fileProgress: 0, displayBar: false })
    this.props.fileUploadFinish(this.state.file, `${API_URL}${e.publicUrl}`, this.props.appeal.data.appealID)
  }

  onUploadStart (file, next) {
    this.setState({ file })
    this.props.fileUploadStarting()
    next(file)
  }

  onProgress (percent) {
    this.setState({ fileProgress: percent })
  }

  onError (e) {
    this.props.fileUploadError()
    this.setState({ fileProgress: 0, displayBar: false })
  }

  render () {
    return (
      <Card>
        <CardTitle>Documents</CardTitle>
        <CardBody>
          <p>Please upload any documents that you feel may help your appeal. e.g. images, copies of permits/parking vouchers, blue badges.</p>
          {

            this.props.files.map((file, i) => {
              const image = JSON.parse(file)

              // Return the element. Also pass key
              return (<p key={i}><a href={image.url} target='_blank'><FaFile /> {image.name}</a></p>)
            })}
          <FormGroup >
            <ReactS3Uploader
              ref={uploader => { this.uploader = uploader }}
              onFinish={this.onFinish}
              onProgress={this.onProgress}
              preprocess={this.onUploadStart}
              onError={this.onError}
              signingUrl={`${API_URL}/s3/sign`}
              signingUrlMethod='GET'
              accept='image/*, application/pdf'
              s3path={`${this.props.appeal.data.appealID}/`}
              uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }} // this is the default
              contentDisposition='inline'
              scrubFilename={(filename) => filename.replace(/[^\w\d_\-.]+/ig, '')}
              autoUpload={false} />

          </FormGroup>
        </CardBody>
        <CardFooter>
          {this.state.displayBar && <Progress color='success' value={this.state.fileProgress} />}
          {this.state.displayBar && <br />}
          <Button color='primary' onClick={this.handleUpload} disabled={this.props.appeal.upload_loading}><FaUpload />Upload document <span className='spinning' /></Button>
        </CardFooter>
      </Card>
    )
  }
}

FileUpload.propTypes = {
  appeal: PropTypes.object,
  files: PropTypes.array,
  fileUploadStarting: PropTypes.func,
  fileUploadError: PropTypes.func,
  fileUploadFinish: PropTypes.func
}

const mapStateToProps = ({ appeal }) => ({
  appeal,
  files: (appeal.data.files) ? Array.from(appeal.data.files.values) : []

})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fileUploadStarting: () => ({ type: '/appeals/FILE_UPLOAD_PENDING' }),
      fileUploadError: () => ({ type: '/appeals/FILE_UPLOAD_FAIL' }),
      fileUploadFinish
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(FileUpload))



// WEBPACK FOOTER //
// ./src/containers/shared/_FileUpload.jsx